import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-cargonizer-printer-edit',
  templateUrl: './cargonizer-printer-edit.component.html',
  styleUrls: ['./cargonizer-printer-edit.component.css']
})
export class CargonizerPrinterEditComponent implements OnInit {
    cargonizerPrinterKeyno;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.cargonizerPrinterKeyno = this.stateService.getStateParams()['cargonizer_printer_keyno'];
    }

    private async loadEdit() {
        if (!!this.cargonizerPrinterKeyno) {
            this.edit = (await this.datatask.Post(426, { cargonizer_printer_keyno: this.cargonizerPrinterKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(427, {
                    cargonizer_printer_keyno: this.edit.cargonizer_printer_keyno,
                    name: this.edit.name
                });

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    cargonizer_printer_keyno: string;
    cargonizer_printer_id: string;
    cargonizer_name: string;
    name: string;
    cargonizer_api_key: string;
    cargonizer_sender_id: string;
}
